export default {
  DateReceivedFrom: 'วันที่รับจาก',
  DateReceivedTo: 'วันที่รับถึง',
  keyword: 'คีย์เวิร์ด',
  HeaderSearching: 'ค้นหาข้อมูล Pathologist',
}
